import React ,{useState} from "react";
import {
  Button,
  Card,
  Grid,
  Dimmer,
  Loader,
} from "semantic-ui-react";
import numeral from "numeral";
import { toast } from "react-toastify";
import CooperatorsAuth from "../../Services/API/CooperatorsAuth";

const SavingsWithdrawal = (props) => {
  const [loading, setLoading] = useState(false);
  const [withdrawalRequest] = useState({
    amount: props.total,
    bizUnit: props.bizUnit,
    reference: props.reference
  });

  const _makeWithdrawal = async () => {
    try {
      setLoading(true);

      let response = await CooperatorsAuth.withdrawalRequest(withdrawalRequest);
      setLoading(false);
      if (response.success) {
        props.onSuccess({ reference: response.objectID },props.paymentMode,props.total);
        props.toggleModal(false);
      } else {
        toast.warn("Transaction failed");
      }
    } catch (error) {
      setLoading(false);
      toast.warn("Transaction failed");

      console.log("error", error);
    }
  };

  return (
    <div>
      {loading && (
        <Dimmer active inverted>
          <Loader />
        </Dimmer>
      )}

      <Grid centered style={{ marginTop: 10, marginBottom: 10 }}>
        <Card centered>
          <Card.Content>
            <Card.Meta>
              Payment for the items will be submitted to the Cooperative for
              approval
            </Card.Meta>
          </Card.Content>
          <Card.Content>
            <Grid columns={2} textAlign="left">
              <Grid.Row>
                <Grid.Column>Amount to Debit</Grid.Column>
                <Grid.Column>
                  <b>₦{numeral(withdrawalRequest.amount).format("0,0")}</b>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Card.Content>
          <Card.Content>
            <Button
              disabled={loading}
          
              onClick={_makeWithdrawal}
              style={{ backgroundColor: '#26f09e', color: '#000000', width: '100%' }}
            >
              Confirm Transfer
            </Button>
          </Card.Content>
        </Card>
      </Grid>
    </div>
  );
};

export default SavingsWithdrawal;
